(function () {

    "use strict";

    angular.module("sphforms.translate", [
        // Angular
        "ngCookies",
        "ngSanitize",
        // External
        "pascalprecht.translate",
        "tmh.dynamicLocale"
    ]);

}());